// @core/api/endpoints/tenant/get_tenant_suspension_history.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetTenantSuspensionHistoryResponse,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Get tenant suspension history
 * Returns the history of all suspensions and reactivations for a tenant, including reasons and actors involved.
 */
export async function GetTenantSuspensionHistory(
  tenant_id: string,
  options?: RequestOptions
): Promise<GetTenantSuspensionHistoryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/suspensions`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.get<GetTenantSuspensionHistoryResponse>(requestPath, { ...requestOptions });
}
